// Predefined prompts configuration for the chat interface
// This file can be easily modified to update prompts without changing the main component

export const PREDEFINED_PROMPTS = [
  {
    id: 1,
    text: "I want a family car",
    icon: "👨‍👩‍👧‍👦",
    category: "family",
    priority: 1
  },
  {
    id: 2,
    text: "Show me SUVs",
    icon: "🚗",
    category: "suv",
    priority: 1
  },
  {
    id: 3,
    text: "I need an electric car",
    icon: "⚡",
    category: "electric",
    priority: 1
  },
  {
    id: 4,
    text: "Find me a small car",
    icon: "🏙️",
    category: "compact",
    priority: 2
  },
  {
    id: 5,
    text: "I want a truck",
    icon: "🚛",
    category: "truck",
    priority: 2
  },
  {
    id: 6,
    text: "Show me sports cars",
    icon: "🏎️",
    category: "sports",
    priority: 2
  },
  {
    id: 7,
    text: "I need a hybrid car",
    icon: "🌱",
    category: "hybrid",
    priority: 2
  },
  {
    id: 8,
    text: "Find me a safe car",
    icon: "🛡️",
    category: "safety",
    priority: 1
  },
  {
    id: 9,
    text: "I want a cheap car",
    icon: "💰",
    category: "budget",
    priority: 1
  }
];

// Helper function to get prompts by category
export const getPromptsByCategory = (category) => {
  return PREDEFINED_PROMPTS.filter(prompt => prompt.category === category);
};

// Helper function to get top priority prompts (for quick actions)
export const getTopPriorityPrompts = (limit = 4) => {
  return PREDEFINED_PROMPTS
    .filter(prompt => prompt.priority === 1)
    .slice(0, limit);
};

// Helper function to get all prompts sorted by priority
export const getPromptsSortedByPriority = () => {
  return [...PREDEFINED_PROMPTS].sort((a, b) => a.priority - b.priority);
};

// Configuration for prompt display
export const PROMPT_CONFIG = {
  maxQuickActions: 4,
  animationDelay: 0.1,
  showCategories: false, // Set to true if you want to group prompts by category
  enablePriority: true
}; 